import { combineEpics } from 'redux-observable';

import { createEventTicketEpic } from './CreateEventTicket/CreateEventTicketEpic';
import { deleteEventTicketEpic } from './DeleteEventTicket/DeleteEventTicketEpic';
import { findEventTicketsEpic } from './FindEventTickets/FindEventTicketsEpic';
import { findEventTicketEpic }   from './FindEventTicket/FindEventTicketEpic';
import { updateEventTicketEpic } from './UpdateEventTicket/UpdateEventTicketEpic';


export const eventTicketEpics = combineEpics(
  createEventTicketEpic,
  deleteEventTicketEpic,
  findEventTicketsEpic,
  findEventTicketEpic,
  updateEventTicketEpic,
);
